


















import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
import { AButton } from '@/components'

@Component({
  components: { AButton }
})
export default class NoResult extends Vue {
  @Prop({
    default() {
      return true
    }
  })
  action!: boolean
  // @Emit()
  public reset() {
    let url = location.origin + location.pathname
    location.replace(url)
  }
  // 点击‘告诉我们’提交反馈
  public onFeedbackClick(e) {
    this.$store.commit('SET_FEEDBACK_STATUS', {}) // 打开反馈弹窗
    e.preventDefault()
  }
}
